import { useState } from 'react';

import { type TicketEvent } from '../tickets.schema';

import { TicketTimelineItem } from './TicketTimelineItem';

const INITIAL = 5;

export function TicketTimeline({ events }: { events: TicketEvent[] }) {
    const [expanded, setExpanded] = useState(false);

    if (events.length === 0) {
        return <p className="text-sm text-gray-500 dark:text-gray-400">Nicio activitate inca.</p>;
    }

    // Events come newest-first, so the initial slice is the most recent activity.
    const shown = expanded ? events : events.slice(0, INITIAL);

    return (
        <div>
            <ul className="flex flex-col">
                {shown.map((e) => (
                    <TicketTimelineItem key={e.id} event={e} />
                ))}
            </ul>
            {events.length > INITIAL && (
                <button
                    type="button"
                    onClick={() => setExpanded((v) => !v)}
                    className="mt-1 text-sm font-medium text-blue-600 hover:text-blue-700 dark:text-blue-400 dark:hover:text-blue-300"
                >
                    {expanded ? 'Vezi mai putine' : `Vezi toate (${events.length})`}
                </button>
            )}
        </div>
    );
}
